export default {
  colorPrimary: '#00d8ff',
  colorOffWhite: '#f7f5f1',
  colorCopper: '#aa694c',
  colorBlack: '#2a2827',
  colorPinkBrown: '#b77356',
};
